import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { API_URL } from '../_common/constants';
import { map } from 'rxjs/operators';
import { ClaimCriteria } from '../claim/claim-list/_models/claim-criteria';
import { ClaimListByPolicyCriteria } from '../policy/claim-list-by-policy/_models/claim-list-by-policy-criteria';
import { FileDownloadService } from './file-download.service';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {

  constructor(private http: HttpClient, private commonService: CommonService, private fileDownloadService: FileDownloadService, private modalService: ModalService) { }
  
  set header(data){
    this.commonService.header = data;
  }
  
  get runningServices(){
    return this.commonService.runningServices;
  }


  storeClaimData(claim){
    let psiData = this.commonService.getData();
    psiData.selectedClaim = claim;
    this.commonService.storeData(psiData);
  }
  
  getClaimData(){
    let psiData = this.commonService.getData();
    return psiData.selectedClaim;
  }

  fetchClaims(criteria: ClaimCriteria):Observable<HttpResponse<any>> {
    return this.http.post<any>(API_URL.Claims, criteria, {observe: 'response'})
        .pipe(map(claims => {
            return claims.body.result;
        }));
  }

  getAccountData(){
    let psiData = this.commonService.getData();
    return psiData.selectedAccount;
  }

  fetchClaimsByPolicy(criteria: ClaimListByPolicyCriteria):Observable<HttpResponse<any>> {
    return this.fetchClaims(criteria);
  }

  fetchClaimDetails(claimNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.Claim+'?claimNumber='+ claimNumber, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  fetchClaimNotes(claimNumber) {
    return this.http.get<any>(API_URL.ClaimNotes+'?claimNumber='+ claimNumber, {observe: 'response'})
    .pipe(map(response => {
        return response.body.result;
    }));
  }

  storeClaimNotesData(claimnotes){
    let psiData = this.commonService.getData();
    psiData.selectedClaim.notes = claimnotes;
    this.commonService.storeData(psiData);
  }

  downloadLossRunReport(number: string, reportBy: string):any {
    return this.fileDownloadService.downloadLossRunReport(number, reportBy);
  }

  openModal(modalType, modalName) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName);
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }
}